<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner
    pageTitle="Blog Details Left Sidebar"
    mainTitle="Blog Details Left Sidebar"
  />
  <BlogDetailsLeftSidebar />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import BlogDetailsLeftSidebar from "../components/BlogDetailsLeftSidebar/BlogDetailsLeftSidebar.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "BlogDetailsLeftSidebarPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    BlogDetailsLeftSidebar,
    DownloadTheApp,
    MainFooter,
  },
});
</script>